import AvailableLanguages from "./availableLanguages";
import {useCallback, useState} from "react";

export default function LanguageTab(props: {
    onChange: (language: string) => void;
    activeLanguage: string;
}){


    const selectLanguage = useCallback((language: string) => {
        if(props.onChange){
            props.onChange(language);
        }
    }, []);

    return (
        <div className="languageChanger">
            {AvailableLanguages().map((language) => {

                return (
                    <div className={`languageInDiv ${props.activeLanguage === language.key && 'active'}`} onClick={() => selectLanguage(language.key)}>
                        {language.name}
                    </div>
                )

            })}
        </div>
    )


}
